import {
  Component, Mixins, ProvideReactive,
} from 'vue-property-decorator';
import PimcoreEntityIntrospection from '@/classes/graphql-introspection/PimcoreEntityIntrospection';
import PimcoreIntrospectionCoreMixin from '@/mixins/PimcoreIntrospectionCoreMixin';

/**
 * Adds reactive provide for FormFactory / Entity grids.
 * Use only on top-level entity screens — not on EntityFilter or other nested loaders.
 */
@Component
export default class PimcoreIntrospectionMixin extends Mixins(PimcoreIntrospectionCoreMixin) {
  @ProvideReactive()
  get pimcoreIntrospection(): PimcoreEntityIntrospection | null {
    return this.pimcoreEntityIntrospection;
  }
}
